import React from 'react';
import { useQuery } from '@apollo/client/react';
import '../Settings.scss';
import { FILENAME_COUNTS } from '../../../services/queries.js';
import DataTable from './DataTable.jsx';

const COLS = [
    { label: 'Filename', key: 'fileName' },
    { label: 'Count',    key: 'recordCount', fmt: v => v?.toLocaleString() },
];

const FileCounts = () => {
    const { data, loading, error } = useQuery(FILENAME_COUNTS, {
        fetchPolicy: 'cache-and-network',
    });

    return (
        <div className="settings-section">
            <h3>File Counts</h3>
            {loading && <div className="settings-loading">Loading...</div>}
            {error && <div className="error">{error.message}</div>}
            <DataTable
                cols={COLS}
                rows={data?.countByFilename ?? []}
                rowKey="fileName"
            />
        </div>
    );
};

export default FileCounts;
